export default "__VITE_ASSET__cRd4dvL8__"